// Current booking deadline
// On DEV/INT, limits are relaxed to allow testing beyond the original deadline.
// On PRD, the original deadline is enforced.
// These are functions so the window flag is read at runtime (not at import time),
// allowing tests to override window.REACT_APP_DISABLE_BOOKING_LIMITS per test case.
export const getBookingEndDateMax = (): Date =>
  window.REACT_APP_DISABLE_BOOKING_LIMITS === true
    ? new Date('2030-03-16T23:59:59.000')
    : new Date('2026-03-16T23:59:59.000')

export const getBookingEndDateMin = (): Date =>
  window.REACT_APP_DISABLE_BOOKING_LIMITS === true
    ? new Date('2025-03-16T00:00:00.000')
    : new Date('2026-03-16T00:00:00.000')

// Backwards-compatible aliases evaluated at import time (for non-test usage)
export const BOOKING_END_DATE_MAX = getBookingEndDateMax()
export const BOOKING_END_DATE_MIN = getBookingEndDateMin()
